import React from 'react'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import {
  color, compose, space, SpaceProps, typography
} from 'styled-system'
import { textStyle } from '@zuto/utilities'

export interface BulletProps extends React.HTMLAttributes<HTMLDivElement>, SpaceProps {
  icon: React.ReactElement
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
  svg {
    flex-shrink: 0;
  }
  ${space}
`

const StyledText = styled.div`
  ${(props) => compose(space, typography, color, textStyle(props))({
    ...themeGet('bullet')(props),
    ...props
  })}
`

const Bullet = ({ children, icon, ...props }: BulletProps): JSX.Element => (
  <Wrapper {...props}>
    {icon && React.cloneElement(icon, { 'data-testid': 'bullet-icon' })}
    <StyledText>{children}</StyledText>
  </Wrapper>
)

export default Bullet
